import { IApplicationState } from '../../types/redux';

export const getIsCompareFlightTooltipShow = (state: IApplicationState): boolean =>
  state.compareFlightTooltip.isCompareFlightTooltipShow;
